import { Select, type SelectProps } from "antd";

/** The 10 most commonly used AWS regions. */
export const AWS_REGIONS = [
	{ value: "us-east-1", label: "US East (N. Virginia)" },
	{ value: "us-east-2", label: "US East (Ohio)" },
	{ value: "us-west-1", label: "US West (N. California)" },
	{ value: "us-west-2", label: "US West (Oregon)" },
	{ value: "eu-west-1", label: "Europe (Ireland)" },
	{ value: "eu-west-2", label: "Europe (London)" },
	{ value: "eu-south-1", label: "Europe (Milan)" },
	{ value: "eu-central-1", label: "Europe (Frankfurt)" },
	{ value: "ap-southeast-1", label: "Asia Pacific (Singapore)" },
	{ value: "ap-southeast-2", label: "Asia Pacific (Sydney)" },
	{ value: "ap-northeast-1", label: "Asia Pacific (Tokyo)" },
];

/**
 * Matches a well-formed AWS ARN: `arn:partition:service:region:account:resource`.
 * Region and account may be empty (some ARNs omit them, e.g. IAM role ARNs).
 */
export const AWS_ARN_REGEX = /^arn:aws[\w-]*:[\w-]+:[\w-]*:\d{0,12}:.+$/;

/** Single AWS region picker. Forwards antd value/onChange, so it works standalone or inside a Form.Item. */
export function AwsRegionSelect(props: SelectProps<string>) {
	return (
		<Select
			style={{ width: "100%" }}
			placeholder="Select a region"
			options={AWS_REGIONS}
			{...props}
		/>
	);
}
